var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPfSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 75C58.2107 75 75 58.2107 75 37.5C75 16.7893 58.2107 0 37.5 0C16.7893 0 0 16.7893 0 37.5C0 58.2107 16.7893 75 37.5 75Z",
    fill: "#FFE8D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2018_2636",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 19,
    width: 31,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 19H22V56H53V19Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2018_2636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.116 24.99L38.0519 19.11C37.8778 19.0369 37.6908 18.9993 37.502 18.9993C37.3131 18.9993 37.1261 19.0369 36.952 19.11L22.887 24.99C22.6238 25.0992 22.3992 25.2845 22.2419 25.522C22.0853 25.7594 22.0019 26.0376 22.002 26.322V33.47C21.9996 38.2767 23.421 42.9764 26.0869 46.976C28.7439 50.9626 32.5296 54.0659 36.9599 55.889C37.3075 56.032 37.6974 56.032 38.045 55.889C42.4751 54.0661 46.2606 50.9627 48.917 46.976C51.5817 42.9774 53.0028 38.2792 53.0009 33.474V26.326C53.0027 26.0406 52.9194 25.7612 52.7618 25.5233C52.6042 25.2854 52.3794 25.0998 52.116 24.99ZM50.1299 33.474C50.1317 37.606 48.9388 41.6504 46.695 45.12C44.4572 48.5793 41.2603 51.3119 37.495 52.984C33.7319 51.3107 30.5376 48.5777 28.3019 45.119C26.0581 41.6497 24.8652 37.6057 24.8669 33.474V27.29L37.497 22.01L50.127 27.29L50.1299 33.474Z",
    fill: "#F48116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9136 38.3469L42.0836 32.1349C42.2163 32.0005 42.3744 31.8938 42.5486 31.8209C42.8571 31.697 43.1988 31.6833 43.5163 31.7819C43.8337 31.8806 44.1074 32.0858 44.2912 32.3627C44.475 32.6397 44.5577 32.9716 44.5254 33.3024C44.493 33.6333 44.3476 33.9428 44.1136 34.1789L36.9286 41.4139C36.7297 41.6175 36.4742 41.7564 36.1953 41.8128C35.9163 41.8692 35.6269 41.8403 35.3646 41.7299C35.19 41.6563 35.0317 41.5489 34.8986 41.4139L30.8816 37.3669C30.7139 37.1988 30.5902 36.992 30.5213 36.7647C30.4524 36.5375 30.4404 36.2968 30.4865 36.0638C30.5325 35.8308 30.6351 35.6128 30.7853 35.4288C30.9355 35.2449 31.1286 35.1007 31.3476 35.0089C31.5219 34.9362 31.7088 34.8987 31.8976 34.8987C32.0864 34.8987 32.2734 34.9362 32.4476 35.0089C32.6216 35.0818 32.7796 35.1881 32.9126 35.3219L35.9136 38.3469Z",
    fill: "#F48116"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfSecurity);
export default __webpack_public_path__ + "static/media/PfSecurity.928204ed27934886fc12dd7830b003be.svg";
export { ForwardRef as ReactComponent };